import React from "react";
// Adjust the path here to your actual image location:
import backgroundImage from "../banner.jpg";
import pt from "../i18n/pt.json";
import en from "../i18n/en.json";
import de from "../i18n/de.json";
import { useLanguage } from "../context/LanguageContext";

function HomePage() {
  const { t } = useLanguage();

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "calc(100vh - 400px)",  // subtract navbar height if you like
        background: `url(${backgroundImage}) center center / cover no-repeat`,
        overflow: "hidden"
      }}
    >
      {/* Dark overlay to make the background darker */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)", // semi-transparent black
        }}
      />

      {/* The big, bold text on the right */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "5%",
          transform: "translateY(-50%)",
          color: "#fff",
          fontSize: "2.5rem",
          fontWeight: "bold",
          maxWidth: "40%",
          textAlign: "right",
          lineHeight: 1.2,
        }}
      >
         {t("home.welcome")}
      </div>
    </div>
  );
}

export default HomePage;
